/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Timecode copy failed" |
*
* @param {Timecode_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_copy_failed = /** @type {((inputs?: Timecode_Copy_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Copy_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la copie des timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Kopie fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia del timecode non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копирование временного кода не удалось.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error en la copia del código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码复制失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードのコピーに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड कॉपी करने में विफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A cópia do código de tempo falhou")
	return /** @type {LocalizedString} */ ("Timecode copy failed")
});